import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-atr',
  templateUrl: './atr.component.html',
  styleUrls: ['./atr.component.scss']
})
export class AtrComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
